export const en:any = {
    jump:'d6387ed9704181f860122340e5a042d661afb50211cf45903c01026db4d756cd',
    jumpOT:'e857tf47tg5881f860122340e5a042d661afb50211cf45903c0174rf85t69874'    
}